import script from "./detection-record.vue?vue&type=script&setup=true&lang=js"
export * from "./detection-record.vue?vue&type=script&setup=true&lang=js"

import "./detection-record.vue?vue&type=style&index=0&id=6fa187db&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa187db"]])

export default __exports__